import algoliasearch from "algoliasearch/lite";
import tableSearch from "../shared/tableSearch/tableSearch.vue";
import CollectionApi from "../../../services/api/collectionApi.js";

const CollectionApiService = new CollectionApi();

export default {
  components: {
    tableSearch,
  },

  data() {
    return {
      query: "",
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      searchIndexCollection: null,
      isTypingSearchQuery: false,
      collections: [],
      pagination: {
        page: 1,
        limit: 12,
        totalCount: 0,
      },
      tabLinks: [
        { name: "Products", path: "products", routeName: "dashboardProducts" },
        { name: "Collections", path: "collections", routeName: "dashboardCollections" },
        { name: "Categories", path: "categories", routeName: "dashboardCategories" },
      ],
    };
  },

  methods: {
    redirect,
    search,
    removeCollection,
    removeCollectionConfirm,
    createNewCollection,
    getCollections,
  },

  beforeMount() {
    this.searchIndexCollection = this.algoliaClient.initIndex(this.$env.getOrigin() + "_collections");

    if (this.$route.query.page) this.pagination.page = Number(this.$route.query.page);
    if (this.$route.query.collection_query) this.query = this.$route.query.collection_query;

    this.$router.replace("/dashboard/collections");
    this.getCollections();
  },
};

function redirect(id) {
  let routeQuery = {
    page: this.pagination.page,
  };

  if (this.query.length) routeQuery.collection_query = this.query;

  this.$router.push({
    name: "editCollection",
    params: { id: id },
    query: routeQuery,
  });
}

function search(val) {
  this.pagination.page = 1;
  this.query = val;
  this.getCollections();
}

function removeCollectionConfirm(id) {
  let _self = this;
  this.$swal({
    title: "Attention",
    text: "Are you sure you want to delete this collection?",
    showCancelButton: true,
    cancelButtonText: "Cancel",
    confirmButtonText: "Confirm",
  }).then(function (confirm) {
    if (confirm.value) {
      _self.removeCollection(id);
    } else {
    }
  });
}

function removeCollection(id) {
  let _self = this;

  CollectionApiService.deleteCollection(id)
    .then((response) => {
      _self.$swal("Success", "You have successfully removed collection! :)").then(function () {
        _self.getCollections(_self.pagination.page);
      });
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$logger.notify(new Error(error));
      }
    });
}

function createNewCollection() {
  this.$router.push("/dashboard/collections/new?page=" + this.pagination.page);
}

function getCollections(page) {
  let _self = this;

  if (page) _self.pagination.page = page;

  _self.searchIndexCollection.clearCache();
  _self.searchIndexCollection
    .search({
      query: this.query,
      hitsPerPage: this.pagination.limit,
      page: this.pagination.page - 1,
    })
    .then((response, err) => {
      if (err) {
        _self.$swal("Attention", _self.$utils.formatErrorMessage("collections"));
        return;
      }

      var collections = [];

      _self.pagination.limit = response.hitsPerPage;
      _self.pagination.totalCount = response.nbHits;

      response.hits.forEach(function (collection) {
        collections.push({
          id: collection.id,
          imageUrl: collection.image_url,
          title: collection.title,
          productConditions: collection.automated_collection_conditions,
        });
      });

      _self.collections = collections;
      _self.$forceUpdate();
    });
}
